export default "__VITE_ASSET__i7_QdWug__"